import { ApiConfig } from '../../config/api';
import { LocalStorageService } from '../storage/LocalStorage';

export interface SessionData {
  sessionId: string;
  payoutIdentifier: string;
  firstPayoutAlreadyFired: boolean;
}

const SESSION_ID_KEY = 'sessionId';
const SESSION_STORE_ID_KEY = 'sessionStoreId';

const generatePayoutIdentifier = (campaignId: string | null, sessionId = '0'): string =>
  `${sessionId}-${campaignId}-${ApiConfig.environment}`;

const generateSessionId = (): string =>
  Math.random().toString(36).substring(2) + Date.now().toString();
const getSessionId = (): string | undefined => LocalStorageService.getItem(SESSION_ID_KEY);
const getSessionStoreId = (): string | undefined =>
  LocalStorageService.getItem(SESSION_STORE_ID_KEY);
const setSessionId = (sessionId: string): void =>
  LocalStorageService.setItem(SESSION_ID_KEY, sessionId);
const setSessionStoreId = (sessionStoreId: string): void =>
  LocalStorageService.setItem(SESSION_STORE_ID_KEY, sessionStoreId);

const getSessionData = (campaignId: string | null): SessionData => {
  const sessionId = getSessionId() ?? generateSessionId();
  const payoutIdentifier = generatePayoutIdentifier(campaignId, sessionId);
  const firstPayoutAlreadyFired = LocalStorageService.hasItem(payoutIdentifier);
  setSessionId(sessionId);

  return {
    sessionId,
    payoutIdentifier,
    firstPayoutAlreadyFired,
  };
};

export const SessionService = {
  generatePayoutIdentifier,
  generateSessionId,
  getSessionId,
  getSessionStoreId,
  setSessionId,
  setSessionStoreId,
  getSessionData,
};
